<template>
  <div v-if="exhibits.length > 0" class="pt-32 border-t filter-panel border-light-gray-4">
    <h3 class="mb-16 font-bold text-18">{{ exhibits.length > 1  ? "Ongoing Exhibits" : "Ongoing Exhibit" }}</h3>
    <div v-for="(exhibit, key) in exhibits.slice(0, 3)"
         :key="key"
         v-if="exhibit.status === 'Ongoing'"
         class="exhibit-card">

      <the-ongoing-exhibit-panel :exhibit="exhibit"/>
    </div>
  </div>
</template>

<script>
import TheGalleryExhibitGird from "./Mixins/TheGalleryExhibitGird";

export default {
  name: "TheGalleryDesktopExhibitGrid",

  mixins: [TheGalleryExhibitGird],
}
</script>

<style scoped>
.exhibit-card:not(:last-child) {
  margin-bottom: 16px;
}
</style>
